const PASSKEY_REGISTERED_ON_DEVICE_KEY =
  "ilovemacumba:passkey:registered-on-device";

export function hasPasskeyRegisteredOnDevice(): boolean {
  try {
    return localStorage.getItem(PASSKEY_REGISTERED_ON_DEVICE_KEY) === "true";
  } catch {
    return false;
  }
}

export function markPasskeyRegisteredOnDevice(): void {
  try {
    localStorage.setItem(PASSKEY_REGISTERED_ON_DEVICE_KEY, "true");
  } catch {
    // Ignore storage failures (private mode, quota, etc.).
  }
}

export function clearPasskeyRegisteredOnDevice(): void {
  try {
    localStorage.removeItem(PASSKEY_REGISTERED_ON_DEVICE_KEY);
  } catch {
    // Ignore storage failures.
  }
}
